export default {
  common: {
    id: {
      en: 'ID',
      zh: '序号',
    },
    email: {
      en: 'Email',
      zh: '邮箱',
    },
    role: {
      en: 'Role',
      zh: '角色',
    },
    save: {
      en: 'Save',
      zh: '保存',
    },
    pattern: {
      en: 'Pattern',
      zh: '匹配规则',
    },
    edit: {
      en: 'Edit',
      zh: '编辑',
    },
    delete: {
      en: 'Delete',
      zh: '删除',
    },
    cancel: {
      en: 'Cancel',
      zh: '取消',
    },
    confirm: {
      en: 'Confirm',
      zh: '确认',
    },
    name: {
      en: 'Name',
      zh: '名称',
    },
    description: {
      en: 'Description',
      zh: '描述',
    },
    operation: {
      en: 'Operation',
      zh: '操作',
    },
    username: {
      en: 'Username',
      zh: '用户名',
    },
    password: {
      en: 'Password',
      zh: '密码',
    },
    usernamePlaceholder: {
      en: 'Input username',
      zh: '请输入用户名',
    },
    passwordPlaceholder: {
      en: 'Input password',
      zh: '请输入密码',
    },
    confirmPassword: {
      en: 'Confirm Password',
      zh: '确认密码',
    },
    confirmPasswordPlaceholder: {
      en: 'Retype Password',
      zh: '再次输入密码',
    },
    oldPassword: {
      en: 'Old Password',
      zh: '旧密码',
    },
    newPassword: {
      en: 'New Password',
      zh: '新密码',
    },
    sendResetPasswordEmail: {
      en: 'Send Reset Password Email',
      zh: '发送重置密码邮件',
    },
    resetPassword: {
      en: 'Reset Password',
      zh: '重置密码',
    },
    bind: {
      en: 'Bind',
      zh: '绑定',
    },
    login: {
      en: 'Login',
      zh: '登录',
    },
    logout: {
      en: 'Logout',
      zh: '登出',
    },
    last_login: {
      en: 'Last Login At',
      zh: '上次登录时间',
    },
    unlock: {
      en: 'Unlock',
      zh: '解锁',
    },
    lock: {
      en: 'Lock',
      zh: '锁定',
    },
    active: {
      en: 'Active Status',
      zh: '启用',
    },
    forbid: {
      en: 'Forbid',
      zh: '禁用',
    },
    size: {
      en: 'Size',
      zh: '大小',
    },
    created_at: {
      en: 'Created at',
      zh: '创建时间',
    },
    modified_at: {
      en: 'Modified at',
      zh: '修改时间',
    },
    updated_at: {
      en: 'Updated at',
      zh: '更新时间',
    },
    dataUpTo: {
      en: 'Data up to',
      zh: '最新数据',
    },
    uploaded_at: {
      en: 'Upload at',
      zh: '上传时间',
    },
    expired_at: {
      en: 'Expired at',
      zh: '到期时间',
    },
    download: {
      en: 'Download',
      zh: '下载',
    },
    download_count: {
      en: 'Download Count',
      zh: '下载次数',
    },
    status: {
      en: 'Status',
      zh: '状态',
    },
    topic: {
      en: 'Topic',
      zh: '类型',
    },
    message: {
      en: 'Message',
      zh: '详情',
    },
    ip: {
      en: 'IP',
      zh: 'IP',
    },
    eventsSearchPlaceholder: {
      en: 'Please input username',
      zh: '请输入用户名',
    },
    selectPlaceholder: {
      en: 'Please select',
      zh: '请选择',
    },
    forever: {
      en: 'Forever',
      zh: '永久',
    },
    expired: {
      en: 'Expired',
      zh: '已过期',
    },
    to: {
      en: 'to',
      zh: '至',
    },
    warning: {
      en: 'Warning',
      zh: '提示',
    },
    stay: {
      en: 'Stay on this page',
      zh: '留在当前页',
    },
    leave: {
      en: 'Leave now',
      zh: '离开',
    },
    times: {
      en: 'times',
      zh: '次',
    },
    sec: {
      en: 'seconds',
      zh: '秒',
    },
    yes: {
      en: 'Yes',
      zh: '是',
    },
    no: {
      en: 'No',
      zh: '否',
    },
    allow: {
      en: 'allowed',
      zh: '允许',
    },
    admin: {
      en: 'administrator',
      zh: '管理员',
    },
    user: {
      en: 'User',
      zh: '普通用户',
    },
    random_password: {
      en: 'Random Password',
      zh: '随机密码',
    },
    bound_weixin: {
      en: 'Bound Weixin',
      zh: '绑定微信',
    },
    application: {
      en: 'Application',
      zh: '应用',
    },
    weixin: {
      en: 'weChat',
      zh: '微信',
    },
    'weixin/miniprogram': {
      en: 'weChat/Miniprogram',
      zh: '微信/小程序',
    },
    wework: {
      en: 'wework',
      zh: '企业微信',
    },
    addFailed: {
      en: 'add failed',
      zh: '添加失败',
    },
    resignFailed: {
      en: 'Resign failed',
      zh: '离职操作失败',
    },
    contactAdmin: {
      en: 'Please contact the administrator',
      zh: '请联系管理员',
    },
  },
  pages: {
    login: {
      WeixinLogin: {
        en: 'Weixin Login',
        zh: '微信登录',
      },
      ForgotPassword: {
        en: 'Forgot Password?',
        zh: '忘记密码?',
      },
      loginTitle: {
        en: 'Log In',
        zh: '登录',
      },
      loading: {
        en: 'Loading...',
        zh: '登录中...',
      },
      loginError: {
        en: 'Wrong Username / Password',
        zh: '用户名或密码错误',
      },
      accountLock: {
        en: 'Account has been locked because too much login failed, please contact administrator to unlock',
        zh: '登录失败过多，账户已锁定，请联系管理员解锁',
      },
      accountLockWarning: {
        en: 'Account will be locked after {count} login failed',
        zh: '用户名或密码错误，您还可以尝试 {count} 次',
      },
      accountForbid: {
        en: 'If username and password are correct, your account might not be actived, please contact administrator.',
        zh: '如果用户名和密码正确, 您的账户可能未激活, 请联系管理员',
      },
    },
    account: {
      email: {
        en: 'Email',
        zh: '注册邮箱',
      },
      newPassword: {
        en: 'New Password',
        zh: '新密码',
      },
      confirmPassword: {
        en: 'Confirm Password',
        zh: '确认密码',
      },
      resetSuccess: {
        en: 'Password has been reset!',
        zh: '密码重置成功!',
      },
      resetFail: {
        en: 'Password reset failed, please try again!',
        zh: '密码重置失败, 请重试',
      },
      expired: {
        en: 'This password reset link has expired. Please try again.',
        zh: '链接已过期,请重试',
      },
      back_to_login: {
        en: 'Back to Login',
        zh: '返回登录页',
      },
    },
    apps: {
      addApp: {
        en: 'Add applications',
        zh: '创建应用',
      },
      id: {
        en: 'ID',
        zh: '应用ID',
      },
      name: {
        en: 'App Name',
        zh: '应用名称',
      },
      description: {
        en: 'App Description',
        zh: '应用描述',
      },
      app_key: {
        en: 'App Key/ App Secret/ Api Key',
        zh: 'App Key/ App Secret/ Api Key',
      },
      is_active: {
        en: 'Active Status',
        zh: '启用',
      },
      base_url: {
        en: 'Base URL',
        zh: 'Base URL',
      },
      allow_create_user: {
        en: 'Create User',
        zh: '在 Hamlet 添加用户',
      },
      manage: {
        en: 'Manage App',
        zh: '应用管理',
      },
      basic: {
        en: 'Basic',
        zh: '基本设置',
      },
      registration_settings: {
        en: 'Registration Settings',
        zh: '注册设置',
      },
      login_settings: {
        en: 'Login Settings',
        zh: '登录设置',
      },
      email_template: {
        en: 'Email Template',
        zh: '邮件模板',
      },
      email_server: {
        en: 'Email Server',
        zh: '邮件服务器',
      },
      enter_app_name: {
        en: 'Please enter the application name',
        zh: '请输入应用名称',
      },
    },
    appSetting: {
      require_email: {
        en: 'Require Email',
        zh: '需要邮箱',
      },
      need_verify_email: {
        en: 'Require verify Email',
        zh: '需要验证邮箱',
      },
      reset_password_callback: {
        en: 'Reset Password URL',
        zh: '重置密码 URL',
      },
      verify_email_callback: {
        en: 'Verify Email URL',
        zh: '验证邮箱 URL',
      },
      password_pattern: {
        en: 'Password Pattern',
        zh: '密码正则',
      },
      password_description: {
        en: 'Password Description',
        zh: '密码描述',
      },
      allow_weixin_login: {
        en: 'Allow WeChat login',
        zh: '允许微信登录',
      },
      force_weixin_login: {
        en: 'Mandatory WeChat login',
        zh: '强制微信登录',
      },
      ignore_weixin_login: {
        en: 'Exempt from forced WeChat login user group',
        zh: '免除「强制微信登录」用户组',
      },
      login_by_email: {
        en: 'Allow Login by Email',
        zh: '允许邮箱登录',
      },
      login_lock: {
        en: 'Allow Login Lock',
        zh: '开启登录锁定',
      },
      login_max_attempts: {
        en: 'Max Login Attempts',
        zh: '登录出错次数',
      },
      access_token_expiration: {
        en: 'Access Token Expiration',
        zh: 'Access Token 有效期',
      },
      refresh_token_expiration: {
        en: 'Refresh Token Expiration',
        zh: 'Refresh Token 有效期',
      },
      need_login_sms: {
        en: 'Enable SMS authentication',
        zh: '开启短信认证',
      },
      password_limit_reuse: {
        en: 'Limit password reuse',
        zh: '限制密码重用(次数)',
      },
      password_expiration: {
        en: 'Password Validity period(s)',
        zh: '密码有效期(s)',
      },
      revoke_on_logout: {
        en: 'Revoke on logout',
        zh: '退出登录时吊销所有 Token',
      },
      revoke_on_change_pwd: {
        en: 'Revoke on change password',
        zh: '被修改密码时吊销所有 Token',
      },
      host: {
        en: 'HOST',
        zh: 'HOST',
      },
      port: {
        en: 'PORT',
        zh: 'PORT',
      },
      use_ssl: {
        en: 'use-SSL',
        zh: 'use-SSL',
      },
      use_tls: {
        en: 'use-TSL',
        zh: 'use-TSL',
      },
      fromname: {
        en: 'Email from name',
        zh: '邮件显示的发件人',
      },
      verify_email: {
        en: 'Verify Email Template',
        zh: '确认邮箱模板',
      },
      reset_password: {
        en: 'Reset Passwor Email Template',
        zh: '重置密码模板',
      },
      bind_user: {
        en: 'Reset Passwor Email Template',
        zh: '绑定用户模板',
      },
      type: {
        en: 'Email Type',
        zh: '主题',
      },
      content: {
        en: 'Content',
        zh: '内容',
      },
      preview: {
        en: 'Preview',
        zh: '预览',
      },
      name: {
        en: 'Name',
        zh: '名称',
      },
      email_notify: {
        en: '* body must be html',
        zh: '* 必须为 HTML 格式',
      },
      update_success: {
        en: 'Update successful',
        zh: '更新成功',
      },
      allow_register: {
        en: 'Allow register',
        zh: '开放注册',
      },
    },
    logs: {
      extra: {
        en: 'Extra',
        zh: '详细',
      },
      selectApp: {
        en: 'Select App',
        zh: '选择应用',
      },
      selectEvent: {
        en: 'Select Event',
        zh: '选择事件',
      },
      timeRange: {
        en: 'Time Range',
        zh: '时间范围',
      },
      search: {
        en: 'Search',
        zh: '查询',
      },
      startDate: {
        en: 'Start Date',
        zh: '开始日期',
      },
      endDate: {
        en: 'End Date',
        zh: '结束日期',
      },
      order: {
        en: 'No.',
        zh: '序号',
      },
      id: {
        en: 'Log ID',
        zh: '日志ID',
      },
      app_name: {
        en: 'App Name',
        zh: '应用名称',
      },
      username: {
        en: 'Username',
        zh: '用户名称',
      },
      event: {
        en: 'Event',
        zh: '事件',
      },
      ip: {
        en: 'IP',
        zh: 'IP 地址',
      },
      created_at: {
        en: 'Created At',
        zh: '时间',
      },
    },
    hamlet_users: {
      searchPlaceholder: {
        en: 'Please input username or email',
        zh: '请输入用户名或邮箱',
      },
      add_user: {
        en: 'Add User',
        zh: '添加用户',
      },
      add_resign_user: {
        en: 'Add Resign User',
        zh: '新增员工离职',
      },
      resign_user: {
        en: 'Resign User',
        zh: '员工离职',
      },
      order: {
        en: 'No.',
        zh: '序号',
      },
      id: {
        en: 'User ID',
        zh: '用户ID',
      },
      username: {
        en: 'User Name',
        zh: '用户名',
      },
      email: {
        en: 'Email',
        zh: '邮箱',
      },
      role: {
        en: 'Role',
        zh: '角色',
      },
      tel: {
        en: 'Phone Number',
        zh: '电话号码',
      },
      applications: {
        en: 'Managing Applications',
        zh: '可管理应用',
      },
      last_login_at: {
        en: 'Last Login',
        zh: '上次登录时间',
      },
      is_active: {
        en: 'Active Status',
        zh: '启用',
      },
      is_locked: {
        en: 'Is Locked',
        zh: '是否锁定',
      },
      locked: {
        en: 'Locked',
        zh: '已锁定',
      },
      resigned: {
        en: 'Resigned',
        zh: '已离职',
      },
      normal: {
        en: 'Normal',
        zh: '正常',
      },
      inactive: {
        en: 'Inactive',
        zh: '禁用',
      },
      status: {
        en: 'Status',
        zh: '状态',
      },
      no_apps: {
        en: 'You have no app now.',
        zh: '您还没有创建应用, 没有可管理的应用',
      },
      select_app: {
        en: 'Select App',
        zh: '选择应用',
      },
      app_name: {
        en: 'App Name',
        zh: '应用名称',
      },
      thirdparty_users: {
        en: 'Third party account',
        zh: '第三方账号绑定',
      },
      usernameIsEmpty: {
        en: 'The user of the email corresponding to the system is empty',
        zh: '系统中邮箱对应的用户为空',
      },
      usernameNotMatch: {
        en: 'The user corresponding to the email in the system is {name}, which does not match the current user',
        zh: '系统中邮箱对应的用户为 {name}，与当前所填用户不匹配',
      },
      emailIsEmpty: {
        en: "The email of user {username} in the system is empty and can't be set",
        zh: '系统中用户 {username} 对应的邮箱为空，不能再设置',
      },
      emailNotMatch: {
        en: "The user's corresponding email in the system is {name}, which does not match the current email",
        zh: '系统中用户对应的邮箱为 {name}，与当前所填邮箱不匹配',
      },
      forceLoginSms: {
        en: 'SMS authentication is required for login',
        zh: '登录时需要短信认证',
      },
    },
    forgot_password: {
      forgotPasswordTitle: {
        en: 'Forgot Password',
        zh: '忘记密码',
      },
      emailPlaceholder: {
        en: 'Please enter login email',
        zh: '请填写登录邮箱',
      },
      successMessage: {
        en: 'Reset email has sent, please confirm',
        zh: '重置邮件已发送，请登录邮箱确认',
      },
    },
  },
  menu: {
    applications: {
      zh: '应用',
      en: 'Application',
    },
    app_users: {
      zh: '应用用户管理',
      en: 'Application User Management',
    },
    user: {
      zh: 'Hamlet 用户管理',
      en: 'Hamlet User Management',
    },
    logs: {
      zh: '操作日志',
      en: 'Logs',
    },
  },
  personal: {
    logout: {
      en: 'Logout',
      zh: '登出',
    },
    setting: {
      en: 'Setting',
      zh: '设置',
    },
    info: {
      en: 'Personal Info',
      zh: '个人信息',
    },
  },
  verify: {
    forbid_user: {
      en: 'User will not be able to login after forbid, are you sure you want to forbid user {username} ? ',
      zh: '禁用后用户不能登录, 确认要禁用 "{username}" 的账号?',
    },
    active_user: {
      en: 'Avtive user account {username}?',
      zh: '确认要启用 "{username}" 的账号?',
    },
    unlock_user: {
      en: 'unlock user account {username}?',
      zh: '确认要解锁 "{username}" 的账号?',
    },
  },
  bind: {
    page: {
      title: {
        en: 'Bind User',
        zh: '用户绑定',
      },
      description: {
        en: 'You are binding your account to the app...',
        zh: '您正在绑定账号到应用…',
      },
    },
    existed_username: {
      en: 'Username Existed',
      zh: '用户名已存在',
    },
    invalid_app_key: {
      en: 'Invalid App Key',
      zh: '应用 Key 无效',
    },
    invalid_token: {
      en: 'Invalid Token',
      zh: 'Token 无效',
    },
    not_bind_to_app: {
      en: 'Email not exists',
      zh: 'Email 不存在',
    },
    bind_user: {
      en: 'User Already Bind',
      zh: '用户已绑定',
    },
    bind_html: {
      en: `Email <span> {email} </span> is bind to App <span>{app_name}</span><br>
           Please click <a href="{app_url}">this link</a> to go to application.`,
      zh: `您的邮箱 <span> {email} </span> 已绑定到应用 <span> {app_name} </span><br>
           点击<a href=" {app_url} ">此链接地址</a>直接登录`,
    },
    success: {
      en: 'Success',
      zh: '成功',
    },
  },
  reset: {
    email_sent_success_html: {
      en: 'An email with a reset link has been sent to your email <span> {email} </span> for your account in {app_name} application',
      zh: '您在应用 {app_name} 的账号 <span> {email} </span> 的重置邮件已经发送',
    },
    email_sent_info_html: {
      en: 'If an account exists for <span> {email} </span>, you\'ll get an email with a reset link on resetting your password for your account in {app_name} application',
      zh: '如果 <span> {email} </span> 账号存在，您将收到一封带有重置 {app_name} 应用用户密码链接的邮件',
    },
    reset_success_html: {
      en: 'Your account <span> {email} </span> password in {app_name} application was successfully updated，<br>please click <a href=" {app_url} ">the link</a> to login',
      zh: '您在应用 {app_name} 的账号 <span> {email} </span> 的密码已重置成功，<br>点击<a href=" {app_url} ">此链接地址</a>直接登录',
    },
    resetPasswordTitle: {
      en: 'Reset Password',
      zh: '重置密码',
    },
    needBindUserErrorMessage: {
      en: 'Email not bind to current application',
      zh: '邮箱未绑定到当前应用',
    },
    resetSuccessMessage: {
      en: 'Password has been reset, please login with new password',
      zh: '密码已重置，请用新密码登录',
    },
    newPassword: {
      en: 'New Password',
      zh: '新密码',
    },
    newPasswordPlaceholder: {
      en: 'Please enter new password',
      zh: '请输入新密码',
    },
    confirmNewPassword: {
      en: 'Confirm New Password',
      zh: '确认新密码',
    },
    confirmNewPasswordPlaceholder: {
      en: 'Retype New Password',
      zh: '再次输入新密码',
    },
  },
  rules: {
    app_name: {
      en: 'Please input app name',
      zh: '请填写应用名称',
    },
    base_url: {
      en: 'Please input base url',
      zh: '请填写应用地址',
    },
    host: {
      en: 'Please input host',
      zh: '请输入主机地址',
    },
    port: {
      en: 'Please input port',
      zh: '请输入端口名称',
    },
    username: {
      en: 'Please input username',
      zh: '请输入合法的用户名',
    },
    has_username: {
      en: 'Username already exists',
      zh: '用户已存在',
    },
    password: {
      en: 'Please input password',
      zh: '请输入密码',
    },
    email: {
      en: 'Email format is wrong',
      zh: '邮箱格式错误',
    },
    has_email: {
      en: 'Email already exists',
      zh: '邮箱已存在',
    },
    require_email: {
      en: 'Email is required',
      zh: '请输入邮箱',
    },
    password_format: {
      en: 'Please enter a combination of number and case sensitive letters with at least 12 characters',
      zh: '密码长度至少十二位且须同时包含数字、小写字母和大写字母',
    },
    password_repeat: {
      en: 'The password and its confirm are not the same',
      zh: '两次密码输入不一致',
    },
    old_password: {
      en: 'PLease input old password',
      zh: '请输入旧密码',
    },
    required_item: {
      en: 'This item is required',
      zh: '此项不可为空',
    },
  },
  thirdPartyLogin: {
    successfulLogin: {
      en: 'Successful login',
      zh: '登录成功',
    },
    logout: {
      en: 'Log out',
      zh: '退出登录',
    },
    needRelogin: {
      en: 'Log in again',
      zh: '重新登录',
    },
    bind: {
      en: 'Bind',
      zh: '绑定',
    },
    unbind: {
      en: 'Unbind',
      zh: '解绑',
    },
    applyForUnbinding: {
      en: 'Request for unbinding',
      zh: '申请解绑',
    },
    completeBinding: {
      en: 'Continue',
      zh: '完成绑定',
    },
    bindSuccessfully: {
      en: 'Successful',
      zh: '绑定成功',
    },
    submittedUnbinding: {
      en: 'The request has been successfully submitted',
      zh: '解绑申请提交成功',
    },
    doNotRemindAgain: {
      en: 'Do not remind me again',
      zh: '不再提示',
    },
    needWeChat: {
      en: '{app} requires binding WeChat for a fast login process',
      zh: '{app} 需要绑定微信，便于下次快捷登录',
    },
    recommendWeChat: {
      en: '{app} recommends binding WeChat for a fast login process',
      zh: '{app} 推荐绑定微信，便于下次快捷登录',
    },
    unbindPrompt: {
      en: 'If you need to switch to another WeChat account, please unbind your current account first and re-authorize your new account',
      zh: '如需切换账号，请取消绑定并重新授权',
    },
    isUnbindWeChat: {
      en: 'Are you sure you want to unbind your WeChat account?',
      zh: '是否确认申请解绑微信？',
    },
    willNotLoginWithWeChat: {
      en: "Once the unbinding is approved, you can't use WeChat login",
      zh: '一旦解绑，将不能使用微信登录',
    },
    unbindingDesc: {
      en: 'The submitted request is waiting to be approved by the administrator',
      zh: '已成功提交解绑申请，等待管理员审核通过',
    },
    enterApp: {
      en: 'You will be redirected to the Personal Center in {time}s',
      zh: '{time}s 后自动进入个人主页',
    },
    backHome: {
      en: 'Back to the Personal Center',
      zh: '返回个人主页',
    },
    boundDescription: {
      en: 'Dear {username}, you have successfully bound WeChat account {weixin}',
      zh: '亲爱的 {username}，您已成功绑定微信 {weixin}',
    },
    enterImmediately: {
      en: 'Enter immediately',
      zh: '立即进入',
    },
    accountHasBeenBound: {
      en: 'The account is bound to the current application',
      zh: '账号已绑定到当前应用',
    },
    accountAlreadyUsed: {
      en: 'The current account has been bound to other WeChat accounts',
      zh: '当前账号已绑定其他微信号，请前往登录页使用对应微信进行登录',
    },
    bindingFailed: {
      en: 'Binding failed, please contact the administrator',
      zh: '绑定失败，请联系管理员',
    },
    accountHasBeenBoundToWeChat: {
      en: 'The current account has been bound to WeChat {nickname}',
      zh: '当前账号已绑定过微信 {nickname}，请前往登录页使用对应微信进行登录',
    },
    unbindingFailed: {
      en: 'Unbinding failed',
      zh: '解绑失败',
    },
    enterVerifyCode: {
      en: 'Enter Verification Code',
      zh: '请输入验证码',
    },
    codeHasBeenSentTo: {
      en: 'Verification code has been sent to:',
      zh: '验证码已发送至：',
    },
    getCode: {
      en: 'Get code',
      zh: '获取验证码',
    },
    getCodeAgain: {
      en: 'Get code again',
      zh: '重新获取验证码',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/locales.js